import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSwitchOff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 3.05H32v25.9h-1.52Zm-1.53 25.9h1.53v1.53h-1.53Zm0-27.43h1.53v1.53h-1.53ZM27.43 25.9h1.52v1.53h-1.52Zm0-21.33h1.52v1.52h-1.52ZM3.05 30.48h25.9V32H3.05ZM22.86 6.09H12.19v1.53h-1.52v6.09h1.52v-1.52h9.15v1.52h-1.53v1.53h-1.52v1.52h-1.53v1.52H7.62v-1.52H6.1v4.57h1.52v-1.52h7.62v1.52H7.62v1.53h3.05v1.52h1.52v-1.52h6.1v-1.53h1.52v-3.05h1.53v-1.52h1.52v7.62h1.52V7.62h-1.52z\"/><path fill=\"currentColor\" d=\"M12.19 24.38h10.67v1.52H12.19ZM9.15 13.71h1.52v1.53H9.15Zm-1.53 1.53h1.53v1.52H7.62ZM3.05 0h25.9v1.52H3.05Zm0 25.9h1.52v1.53H3.05Zm0-21.33h1.52v1.52H3.05ZM1.53 28.95h1.52v1.53H1.53Zm0-27.43h1.52v1.53H1.53ZM0 3.05h1.53v25.9H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSwitchOff
